import React from 'react';

import Button from '../../../Components/button';

import { PageSejaExpositorInterface } from '../../../Services/types';
interface PageInterface {
    expositor: PageSejaExpositorInterface | null
}

const ContentSection: React.FC<PageInterface> = ({expositor}: PageInterface) => {

    return (
        <section className='pt-4 pb-12 md:-mt-8'>
            <div className="max-w-screen-lg mx-auto px-4">                        
                {expositor && (
                    <div className="grid items-center gap-12 pt-8">
                        <div>
                            <h3 className="flex text-2xl flex-col font-semibold" 
                                dangerouslySetInnerHTML={{ __html: expositor.title }} />
                                
                            <div className="mt-4 text-sm 2xl:text-base" 
                                dangerouslySetInnerHTML={{ __html: expositor.content }} />

                            <div className="mt-10 grid md:grid-cols-2 gap-4 max-w-[470px]">
                                {expositor.botoes &&
                                    expositor.botoes.map((button, index) => (
                                        <div key={index} className="max-w-64 w-full">
                                            <Button target='_blank' text={button.text} link={button.link} arrow={false} color="pink" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ContentSection;